import parseToken from '../helpers/parseToken';
import handleFetchErrors from '@adsk/bim360-matrix-react-helpers/es/handleFetchErrors';

const handleError = response => {
  if ([401, 403].includes(response.status)) {
    throw response;
  }
  return response;
};

export const fetchToken = docsUrl =>
  fetch(`${docsUrl}/session/token?validate_token=true`, { credentials: 'include' })
    .then(handleError)
    .then(handleFetchErrors)
    .then(res => res.json())
    .then(parseToken);
